import { IBasketItem, ItemType } from "lib/basket/types";
import { BookBasketItem } from "./book";
import { ProductBasketItem } from "./product";
import { SubscriptionBasketItem } from "./subscription";
import { TicketBasketItem } from "./ticket";
import { VoucherBasketItem } from "./voucher";

interface Props {
  item: IBasketItem<ItemType>;
}

export const BasketItem = ({ item }: Props) => {
  if (item.type === "book") {
    return <BookBasketItem bookItem={item as IBasketItem<"book">} />;
  }

  if (item.type === "product") {
    return <ProductBasketItem productItem={item as IBasketItem<"product">} />;
  }

  if (item.type === "voucher") {
    return <VoucherBasketItem voucherItem={item as IBasketItem<"voucher">} />;
  }

  if (item.type === "subscription") {
    return (
      <SubscriptionBasketItem subItem={item as IBasketItem<"subscription">} />
    );
  }

  if (item.type.includes("ticket")) {
    return (
      <TicketBasketItem
        ticketItem={
          item as IBasketItem<
            | "ticket-voucher"
            | "ticket-online-voucher"
            | "ticket-free"
            | "ticket-online-free"
            | "ticket-book"
            | "ticket-online-book"
          >
        }
      />
    );
  }

  return null;
};
